import {
  INormalizedPayload,
  defaultEntityState,
} from '@app/core/state/entities/entity';
import {
  mergeEntityState,
  removeEntities,
  removeEntitiesByFilter,
} from '@app/core/state/entities/entity.helpers';
import { projectDetailActions } from '@app/core/actions/project-detail.actions';
import { IInvitation } from '@core/state/entities/invitation/invitation.entity';
import { createReducer, on } from '@ngrx/store';
import { entityKey } from '@core/state/entities/entity-name-map';

export const invitationEntityReducer = createReducer(
  defaultEntityState<IInvitation>(),
  on(
    projectDetailActions.created,
    projectDetailActions.detailLoaded,
    projectDetailActions.projectForInvitationRetrieved,
    projectDetailActions.requestToJoinProjectResponseReceivedAndGranted,
    projectDetailActions.invitationsBulkRevokedSuccessfully,
    projectDetailActions.joinRequestsResponseSent,
    projectDetailActions.invitationGroupsBulkUpdatedSuccessfully,
    projectDetailActions.invitationsBulkResentSuccessfully,
    projectDetailActions.projectUpdated,
    projectDetailActions.projectListingUpdated,
    projectDetailActions.registered,
    projectDetailActions.projectListingsLoaded,
    (state, props) => mergeEntityState(entityKey.invitations, state, props)
  ),
  on(projectDetailActions.projectDeleted, (state, props) =>
    removeEntitiesByFilter(
      state,
      (invitation) => invitation.projectId === props.projectId
    )
  )
);
